import { Config } from './config';
import { Util } from './util';
import { Cookie } from './cookie';
import { SearchForm } from './search_form';
import { ComplaintsTable } from './complaints_table'
import AmountFormatter from '../../libraries/amount-formatter'

class Show {

    constructor() {
        this.AMOUNT_FORMATTER = new AmountFormatter();
        this.CONFIG = new Config();
        this.SEARCH_FORM = new SearchForm();
        this.COMPLAINTS_TABLE = new ComplaintsTable();
    }


    handleSearchBefore(e) {
        if(!e.detail.isSearchingMore) {
            this.COMPLAINTS_TABLE.Clear();
        }
        this.COMPLAINTS_TABLE.HiddenNoComplaintsP();
        this.COMPLAINTS_TABLE.LoadingStart();
    }


    handleSearchComplete() {
        this.COMPLAINTS_TABLE.LoadingStop();
    }


    handleSearched(e) {
        if(e.detail != null && e.detail.isNotFound) {
            this.COMPLAINTS_TABLE.VisibleNoComplaints();
        } else {
            this.COMPLAINTS_TABLE.HiddenNoComplaintsP();
        }
        this.COMPLAINTS_TABLE.Append(e.detail.objects);
    }


    handleScrollBottomDetected() {
        this.SEARCH_FORM.GetMoreComplaints();
    }


    setUpSearchFormEventListener() {
        this.SEARCH_FORM.GetRootElm().addEventListener('searchbefore', (e) => { this.handleSearchBefore(e); }, false);
        this.SEARCH_FORM.GetRootElm().addEventListener('searched', (e) => { this.handleSearched(e); }, false);
        this.SEARCH_FORM.GetRootElm().addEventListener('searchcomplete', () => { this.handleSearchComplete(); }, false);
    }


    setUpComplaintsTableEventListener() {
        this.COMPLAINTS_TABLE.GetRootElm().addEventListener('scrollbottomdetected', () => { this.handleScrollBottomDetected(); }, false);
    }


    handleNotification() {
        if(Cookie.Get(this.CONFIG.COOKIE_NAME_NOTIFICATION) === '') {
            return;
        }
        this.CONFIG.APP_MAIN.insertBefore(Util.GenFlashSuccess(Cookie.Get(this.CONFIG.COOKIE_NAME_NOTIFICATION)), this.CONFIG.APP_MAIN.childNodes[0]);
        Cookie.Delete(this.CONFIG.COOKIE_NAME_NOTIFICATION, new URL(this.CONFIG.URL_COMPLAINTS).pathname);
    }


    Run() {
        this.AMOUNT_FORMATTER.Run();
        this.SEARCH_FORM.Run();
        this.COMPLAINTS_TABLE.Run();
        this.setUpSearchFormEventListener();
        this.setUpComplaintsTableEventListener();
        this.handleNotification();
    }

}
export { Show }
